<template>
  <div
    class="has-text-left"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >

    <div
      class="modal small"
      :class="{ 'is-active': updateMessage.modalActive }"
      id="cryptoBlockModal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <button
            class="delete custom-delete"
            @click="updateMessage.modalActive = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="content has-text-left">
            <p v-html="$t('crypto_note_text')"></p>
          </div>
        </section>
      </div>
    </div>

    <div
      class="box"
      :class="{'fa': Language == 'fa' || Language == 'ar'}"
    >
      <h4
        class="title"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >
        <span class="has-text-danger">{{$t("please_note")}}</span>
        {{$t("lydiax_note")}}
      </h4>
      <p
        class="subtitle"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{ $t('lydiax_note1', { crypto: selectedCrypto.name || 'crypto'}) }}</p>
    </div>

    <div
      class="box"
      :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
    >
      <h4 class="title">
        <span class="has-text-danger">{{$t("price_estimate")}}</span>
      </h4>
      <p class="subtitle">{{ $t('lydiax_note2', { crypto: selectedCrypto.name || 'crypto'}) }}</p>

      <div class="box">
        <div class="field">
          <p class="control">
            <label
              class="label"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              for="estimate"
            >{{ $t('please_enter_crypto_amount', { crypto: selectedCrypto.name || 'crypto'}) }}</label>
            <input
              class="input"
              v-validate="'decimal:10'"
              name="estimate"
              type="text"
              v-model="estimate.crypto"
            />
            <span
              v-show="errors.has('estimate')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('estimate') }}</span>
          </p>
        </div>

        <a
          class="button is-success"
          @click="estimatePrice"
        >
          <span class="icon is-small">
            <i
              class="fa fa-check"
              :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
            ></i>
          </span>
          <span>{{$t("check_price")}}</span>
        </a>

        <span
          class="is-size-5 has-text-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          v-if="estimate.fiat"
        >Estimated: {{ $formatMoney(estimate.fiat, currencySymbols[User.wallet.currency]) }}</span>
      </div>
    </div>

    <div v-if="address === '' && availableCryptoOptions.length">
      <h5 class="title">{{$t("lydiax_enter_deposit")}}</h5>

      <div class="control">
        <span class="select">
          <select
            name="currency"
            v-model="cryptocurrency"
          >
            <option
              v-if="crypto.code !== 'ETH'"
              :value="crypto.code"
              v-for="(crypto, i) in availableCryptoOptions"
              :key="'crypto-options-' + i"
            >{{ crypto.name }}</option>
          </select>
        </span>
      </div>

      <br />

      <div v-if="networkOpts.length > 1">
        <h5 class="title">Select your {{cryptocurrency}} network:</h5>
        <div class="control">
          <span class="select">
            <select
              name="currency"
              v-model="network"
            >
              <option
                :value="netw"
                v-for="(netw, i) in networkOpts"
                :key="'network-' + i"
              >{{ netw }}</option>
            </select>
          </span>
        </div>
      </div>

      <div
        v-if="networkWarning[cryptocurrency] && networkWarning[cryptocurrency].length > 0"
        class="has-text-danger"
      >
        <!-- {{networkWarning[cryptocurrency]}} -->
        <div v-if="cryptocurrency=='BTC'">
          {{$t('bitpace_network_warning_BTC')}}
        </div>
        <div v-else-if="cryptocurrency=='ETH'">

        </div>
        <div v-else-if="cryptocurrency=='LTC'">
          {{$t('bitpace_network_warning_LTC')}}
        </div>
        <div v-else-if="cryptocurrency=='XRP'">
          {{$t('bitpace_network_warning_XRP')}}
        </div>
        <div v-else-if="cryptocurrency=='BCH'">
          {{$t('bitpace_network_warning_BCH')}}
        </div>
        <div v-else-if="cryptocurrency=='USDT'">
          {{$t('bitpace_network_warning_USDT')}}
        </div>
        <div v-else-if="cryptocurrency=='USDC'">
          {{$t('bitpace_network_warning_USDC')}}
        </div>
        <div v-else-if="cryptocurrency=='TRX'">
          {{$t('bitpace_network_warning_TRX')}}
        </div>
        <div v-else-if="cryptocurrency=='LINK'">
          {{$t('bitpace_network_warning_LINK')}}
        </div>
      </div>

      <br v-if="networkWarning[cryptocurrency] && networkWarning[cryptocurrency].length > 0" />

      <p>
        <a
          class="button is-success"
          @click="deposit"
        >
          <span class="icon is-small">
            <i class="fa fa-check"></i>
          </span>
          <span>{{$t("create_address")}}</span>
        </a>
      </p>

      <p class="subtitle">{{$t("lydiax_note3")}}</p>
    </div>
    <div v-else>
      <h5
        class="title"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{ $t('lydiax_note4', { crypto: selectedCrypto.name}) }}</h5>
      <pre class="has-text-danger has-text-weight-bold">{{ address }}</pre>
      <p v-if="selectedCrypto.code === 'XRP'">
        {{$t("lydiax_required_address")}}
        {{$t("address").tTitle()}}:
        <code>{{ xrp.address }}</code>
        <br />
        {{$t("tag")}}:
        <code>{{ xrp.tag }}</code>
      </p>
      <p>{{$t('crypto_visit_page')}}</p>
      <!-- <p :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{ $t('lydiax_note5', { crypto: selectedCrypto.name}) }}</p> -->
    </div>

    <!-- <div
      class="has-text-danger"
      style="font-weight:700; font-size:1.25rem; margin-bottom: 0;"
      v-if="selectedCrypto.fees.deposit"
    >
      Please note that a {{ selectedCrypto.fees.deposit }} {{ cryptocurrency }} fee applies.
    </div> -->
  </div>
</template>

<script>
import config from '../../../config'
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../../app'

export default {
  data() {
    return {
      cryptocurrency: 'BTC',
      network: '',
      availableCrypto: [],
      cryptocurrencyOptions: config.cryptocurrencyOptions,
      address: '',
      amount: 0,
      estimate: {
        crypto: 0,
        fiat: 0,
        raw: {},
      },
      translations: {
        text: {
          amount: this.$t('amount'),
        },
      },
      currencySymbols: config.currencies,
      updateMessage: {
        modalActive: true,
      },
      networkOpts: [],
      networkWarning: {
        BTC: this.$t('bitpace_network_warning_BTC'),
        ETH: '',
        LTC: this.$t('bitpace_network_warning_LTC'),
        XRP: this.$t('bitpace_network_warning_XRP'),
        BCH: this.$t('bitpace_network_warning_BCH'),
        USDT: this.$t('bitpace_network_warning_USDT'),
        USDC: this.$t('bitpace_network_warning_USDC'),
        TRX: this.$t('bitpace_network_warning_TRX'),
        LINK: this.$t('bitpace_network_warning_LINK'),
      },
      fee: {
        BTC: 0.00001,
        ETH: 0.00001,
      },
    }
  },
  watch: {
    cryptocurrency() {
      this.networkOpts = this.selectedCrypto.networks
      if (this.networkOpts.length == 0) {
        this.network = ''
      }
      if (this.networkOpts.length == 1) {
        this.network = this.networkOpts[0]
      }
    },
  },
  computed: {
    xrp() {
      if (!this.selectedCrypto || this.selectedCrypto.code !== 'XRP') {
        return ''
      }
      const x = this.address.split('?dt=')
      return { address: x[0], tag: x[1] }
    },
    availableCryptoOptions() {
      return this.cryptocurrencyOptions.filter(c => this.availableCrypto.indexOf(c.code) !== -1)
    },
    selectedCrypto() {
      return this.cryptocurrencyOptions.filter(c => c.code === this.cryptocurrency)[0] || {}
    },
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    this.networkOpts = this.selectedCrypto.networks

    this.network = this.networkOpts[0]
    this.getAvailableCrypto()
  },
  methods: {
    getAvailableCrypto() {
      this['logoLoader/set'](true)
      service
        .get('finance/get-available-lydiax-crypto')
        .then(response => {
          this.availableCrypto = response.data.crypto
          this['logoLoader/set'](false)
        })
        .catch(error => {
          console.log(error)
          this['logoLoader/set'](false)
        })
    },
    estimatePrice() {
      this.estimate.fiat = 0
      this.estimate.raw = {}

      this['logoLoader/set'](true)
      service
        .post('finance/get-lydiax-price', {
          order_type: 'sell',
          crypto: this.cryptocurrency,
        })
        .then(response => {
          const orderPrice = response.data
          if (orderPrice.currency !== this.User.wallet.currency) {
            service.get('/finance/rates/' + orderPrice.currency + '/' + this.User.wallet.currency).then(response => {
              this.estimate.fiat = orderPrice.price * response.data.rate * this.estimate.crypto
            })
          } else {
            this.estimate.fiat = orderPrice.price * this.estimate.crypto
          }

          this.estimate.raw = orderPrice
          this['logoLoader/set'](false)
        })
        .catch(error => {
          console.log(error)
          this['logoLoader/set'](false)
        })
    },
    deposit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return false
        }
        this.$bus.$emit(
          'RequestDeposit',
          '/finance/deposit/lydiax',
          {
            cryptocurrency: this.cryptocurrency,
            amount: String(this.amount),
            userID: this.$store.state.user.info.ID,
            network: this.cryptocurrency === 'USDT' || this.cryptocurrency === 'USDC' ? this.network : '',
          },
          response => {
            if (response.data.success) {
              this.address = response.data.redirectURL
              this['logoLoader/set'](false)
            }
          }
        )
      })
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>

<style lang="scss" scoped>
label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// Lydiax.vue?45abc4e8